import React from "react";
import s from "./index.css";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import html2canvas from "html2canvas";
import { convertCanvasToImage, saveFile } from "../../../utils";
import Button from "../components/Button";
import TextSplitContainer from "./TextSplitContainer";
import logo from "../components/image/highlight_logo.png";
import highLight_text from "../components/image/highLight_text.png";
import yuanBg from "../components/image/yuan.png";
import borderImage from "../components/image/highLight_border.png";
import TooltipDrawer from "../components/TooltipDrawer";
import Form from "./FormTitle";
import FormList from "./FormList";

class P45 extends React.Component {
  // 调用函数，假设容器宽度为200px
  constructor(props) {
    super(props);
    this.state = {
      dataset: "",
      dataList: [],
    };
  }
  // 截图并下载
  captureAndDownload = () => {
    // 通过class选择器获取所有要截图的div
    const divs = document.querySelectorAll(".PageBox");
    const w = divs.offsetWidth;
    const h = divs.offsetHeight;

    Array.from(divs).forEach((div, index) => {
      html2canvas(div, {
        useCORS: true,
        scale: 2, // 将画布的尺寸放大到原始尺寸的两倍
        logging: false,
        foreignObjectRendering: true,
      }).then((canvas) => {
        const src = convertCanvasToImage(canvas).src;
        saveFile(src, `highlight`);

        // link.click();
      });
    });
  };

  render() {
    const { dataset, dataList } = this.state;
    console.log(dataset);
    const longText = dataset;
    return (
      <div className={s.appBox}>
        <Button
          type="primary"
          onClick={this.captureAndDownload}
          style={{ margin: "10px 10px ", display: "inline" }}
        >
          下载
        </Button>

        <div
          className="PageBox"
          style={{
            width: "680px",
            height: "auto",
          }}
        >
          <div className={s.InnerBox}>
            <div className={s.inner_logo}>
              <img src={logo} />
            </div>
            <div className={s.inner_title}>
              <TooltipDrawer
                formContent={
                  <Form onChange={(values) => this.setState({ ...values })} />
                }
              >
                <TextSplitContainer
                  text={longText}
                  width={400}
                  height={50}
                  fontSize={30}
                />
              </TooltipDrawer>
            </div>
            <div className={s.inner_logoText}>
              <img src={highLight_text} />
            </div>
            <TooltipDrawer
              formContent={
                <FormList onChange={(values) => this.setState({ ...values })} />
              }
            >
              <div className={s.inner_con}>
                {dataList.map((item) => {
                  return <div className={s.contItem}>{item[0]}</div>;
                })}
              </div>
            </TooltipDrawer>
            <div className={s.inner_author}>
              <img src={yuanBg} />
              <span contentEditable>作者 | 双安</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withStyles(s)(P45);



// WEBPACK FOOTER //
// src/routes/visualChart/P45/index.js